import differenceInDays from 'date-fns/differenceInDays';
import dateFnsFormat from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import parse from 'date-fns/parse';
import { DATE_FORMAT, DATE_RANGE_SEPARATOR } from '../consts.js';

function parseDateString(value, format) {
    if (format === void 0) { format = DATE_FORMAT; }
    return parse(value, format, new Date());
}
var formatDate = function (date, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DATE_FORMAT; }
    return dateFnsFormat(date, dateFormat);
};
function isCompleteDate(value) {
    if (value === void 0) { value = ''; }
    return value.length === DATE_FORMAT.length;
}
function isCompleteTime(value, withTime) {
    if (value === void 0) { value = ''; }
    if (withTime === void 0) { withTime = false; }
    if (!withTime)
        return true;
    return value.length === 5;
}
function isCompleteDateRange(value) {
    if (value === void 0) { value = ''; }
    return value.length === DATE_RANGE_SEPARATOR.length + DATE_FORMAT.length * 2;
}
function isValidDate(_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, minDate = _a.minDate, maxDate = _a.maxDate, offDays = _a.offDays;
    var parsed = isCompleteDate(value) ? parseDateString(value).getTime() : undefined;
    if (parsed) {
        return (parsed >= minDate &&
            parsed <= maxDate &&
            !(offDays === null || offDays === void 0 ? void 0 : offDays.some(function (offDay) { return isSameDay(offDay, parsed); })));
    }
    return false;
}
function preventDefault(e) {
    e.preventDefault();
}
function getValidRange(_a) {
    var from = _a.from, to = _a.to, offDays = _a.offDays, minDate = _a.minDate, maxDate = _a.maxDate;
    var isValidFrom = isValidDate({ value: from, maxDate: maxDate, minDate: minDate, offDays: offDays });
    var isValidTo = isValidDate({ value: to, maxDate: maxDate, minDate: minDate, offDays: offDays });
    return {
        validFrom: isValidFrom ? parseDateString(from) : undefined,
        validTo: isValidTo ? parseDateString(to) : undefined,
    };
}
/**
 * Частично копипаста updatePeriod хука в календаре
 */
function updateRange(_a) {
    var date = _a.date, validFrom = _a.validFrom, validTo = _a.validTo, rangeBehavior = _a.rangeBehavior;
    var selectedFrom = validFrom ? validFrom.getTime() : null;
    var selectedTo = validTo ? validTo.getTime() : null;
    if (rangeBehavior === 'clarification') {
        if (date === undefined || (date === selectedFrom && date === selectedTo)) {
            selectedFrom = null;
            selectedTo = null;
        }
        else if (date === selectedTo) {
            selectedTo = null;
        }
        else if (date === selectedFrom) {
            if (selectedTo) {
                selectedFrom = selectedTo;
                selectedTo = null;
            }
            else {
                selectedTo = date;
            }
        }
        else if (!selectedFrom) {
            if (selectedTo) {
                selectedFrom = Math.min(date, selectedTo);
                selectedTo = Math.max(date, selectedTo);
            }
            else {
                selectedFrom = date;
            }
        }
        else if (!selectedTo) {
            selectedTo = Math.max(date, selectedFrom);
            selectedFrom = Math.min(date, selectedFrom);
        }
        else if (Math.abs(differenceInDays(date, selectedTo)) >
            Math.abs(differenceInDays(date, selectedFrom))) {
            selectedFrom = date;
        }
        else {
            selectedTo = date;
        }
    }
    if (rangeBehavior === 'reset') {
        if (date === undefined || (date === selectedFrom && date === selectedTo)) {
            selectedFrom = null;
            selectedTo = null;
        }
        else if (!selectedFrom && selectedTo) {
            selectedFrom = Math.min(date, selectedTo);
            selectedTo = Math.max(date, selectedTo);
        }
        else if (!selectedFrom) {
            selectedFrom = date;
        }
        else if (!selectedTo) {
            selectedTo = Math.max(date, selectedFrom);
            selectedFrom = Math.min(date, selectedFrom);
        }
        else {
            selectedTo = null;
            selectedFrom = date;
        }
    }
    var dateFrom = selectedFrom ? formatDate(selectedFrom) : null;
    var dateTo = selectedTo ? formatDate(selectedTo) : null;
    if (dateFrom && dateTo) {
        return "".concat(dateFrom).concat(DATE_RANGE_SEPARATOR).concat(dateTo);
    }
    if (dateFrom)
        return dateFrom;
    return '';
}

export { formatDate, getValidRange, isCompleteDate, isCompleteDateRange, isCompleteTime, isValidDate, parseDateString, preventDefault, updateRange };
